<template>
  <section>
    <div class="container">
      <div class="row">
        <div class="col-12 text-center mb-5">
          <h1>Vos documents</h1>
        </div>
        <div class="col-12">
          <div class="row justify-content-center">
            <div
              v-for="(product, index) in productsList"
              :key="product.id"
              class="col-12 col-sm-8 col-md-4 my-2"
            >
              <router-link
                v-slot="{ navigate }"
                :to="`/client/documents/${product.id}`"
                custom
              >
                <div
                  class="card cursor-pointer shadow"
                  style="height:264px"
                  @click="navigate"
                >
                  <span
                    v-for="i in 3"
                    :key="i"
                    class="pills-image"
                    :class="[ `pill-card-${(index % 4) + 1}-${i}` ]"
                  />
                  <div
                    class="card-body d-flex text-center transition-shadow rounded-4"
                    :class="`box-shadow-${boxShadowColor(product.id)}
                      box-shadow-hover-${boxShadowColor(product.id)}`"
                  >
                    <h5 class="m-auto">
                      <v-highlight
                        :product-id="product.id"
                        :product-name="product.name"
                      />
                    </h5>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-no-resource v-if="productsList.length === 0">
      <div class="d-flex flex-column">
        <div class="lead">
          Aucun document disponible.
        </div>
        <div class="lead">
          On dirait que vous n’avez
          pas encore souscrit votre contrat chez nous !
        </div>
        <div class="mt-2">
          <a
            :href="getAppUrl('')"
            class="btn btn-primary fs-5 fw-bold"
          >
            Ajouter un nouveau contrat
          </a>
        </div>
      </div>
    </v-no-resource>
  </section>
</template>
<script>
import { mapGetters } from 'vuex';
import ProductHighlight from '@/components/common/helpers/ProductHighlight.vue';

export default {
  name: 'DocumentsHome',
  components: {
    'v-highlight': ProductHighlight,
  },
  computed: {
    ...mapGetters({
      contracts: 'contracts/get',
      documents: 'contracts/certificates',
      products: 'rater/products',
    }),
    productsList() {
      const currentYear = new Date().getFullYear();
      const productsId = new Set(this.documents
        .map(({ productId }) => productId)
        .filter(Boolean));
      this.contracts
        .filter(({ status }) => ['ACTIVE', 'SUSPENDED'].includes(status))
        .filter(({ effectiveDate, endEffectiveDate }) => {
          const startYear = effectiveDate ? new Date(effectiveDate).getFullYear() : null;
          const endYear = endEffectiveDate ? new Date(endEffectiveDate).getFullYear() : null;
          return startYear === currentYear || endYear === currentYear;
        })
        .forEach(({ productId }) => productsId.add(productId));
      return this.products
        .filter(({ id }) => productsId.has(id))
        .map((elem) => Object.assign(elem, { priority: elem.priority || 1000 }))
        .sort(({ priority: a }, { priority: b }) => a - b)
        .map(({ name, id, priority }) => ({ name, id, priority }))
        || [];
    },
  },
  methods: {
    getAppUrl(url) {
      return `${import.meta.env.VITE_WIDGET_URL}${url}`;
    },
    boxShadowColor(productId) {
      const id = parseInt(productId, 10);
      switch (id) {
        case 1:
        case 18:
          return 'pink-300';
        case 2:
        case 4:
          return 'blue-300';
        case 5:
        case 13:
          return 'yellow-300';
        default:
          return 'green-300';
      }
    },
  },
};
</script>
<style scoped>
.pills-image {
  height: 12px;
  border-radius: 60px;
  position: absolute;
  z-index: 3;
}

.pill-card-1-1 {
  left: 20px;
  width: 39px;
  top: 35%;
  background-color: var(--bs-yellow-300);
}
.pill-card-1-2 {
  left: 30px;
  width: 64px;
  bottom: 10%;
  background-color: var(--bs-green-300);
}
.pill-card-1-3 {
  bottom: 14%;
  width: 48px;
  right: 30px;
  background-color: var(--bs-pink-300);
}

.pill-card-2-2 {
  left: 30px;
  width: 50px;
  height: 10px;
  bottom: 20%;
  background-color: var(--bs-green-300);
}
.pill-card-2-3 {
  bottom: 10%;
  width: 33px;
  right: 30px;
  background-color: var(--bs-pink-300);
}

.pill-card-3-1 {
  top: 30%;
  width: 39px;
  height: 8px;
  right: 30px;
  background-color: var(--bs-yellow-300);
}
.pill-card-3-2 {
  bottom: 17%;
  width: 30px;
  right: 30px;
  background-color: var(--bs-green-300);
}
.pill-card-3-3 {
  bottom: 20%;
  width: 32px;
  left: 40px;
  background-color: var(--bs-blue-300);
}

.pill-card-4-1 {
  top: 35%;
  width: 32px;
  left: 20px;
  background-color: var(--bs-blue-300);
}
.pill-card-4-2 {
  bottom: 20%;
  width: 32px;
  left: 40px;
  background-color: var(--bs-yellow-300);
}
.pill-card-4-3 {
  bottom: 13%;
  width: 48px;
  right: 30px;
  background-color: var(--bs-pink-300);
}
</style>
